import { initialState } from '../reducers/builder';

export const createAddPageDataPayload = (uiKey, uiValue, serverKey, serverValue) => {
  if (serverKey && serverValue !== undefined) {
    return { serverKey, serverValue, uiKey, uiValue };
  }

  return { uiKey, uiValue };
};

export const createResetPageDataPayload = (uiKey, serverKey) => {
  const { ui } = initialState;

  if (serverKey) {
    return {
      serverKey,
      serverValue: null,
      uiKey,
      uiValue: ui[uiKey] || null,
    };
  }

  return {
    uiKey,
    uiValue: ui[uiKey] || null,
  };
};

export const createResetPageObjectPayLoad = (uiKey, serverKey) => {
  if (serverKey) {
    return {
      serverKey,
      serverValue: {},
      uiKey,
      uiValue: {},
    };
  }

  return {
    uiKey,
    uiValue: {},
  };
};
